<template>
  <div class="container help">
    <div class="img_wrap">
      <img src="../../assets/img/help3.jpg" alt="">
    </div>
    <home :ishome=0></home>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
import home from '../common/home.vue'
  export default {
    data() {
      return {}
    },
    components: {
    home
  },
    computed: {
      ...mapGetters({}),

    },
    watch: {},
    created() {

    },
    methods: {},
    mounted() {
    }
  }
</script>